import { Quote, Star } from "lucide-react";
import Reveal from "@/components/Reveal";
import { testimonials } from "@/mock/mock";

export default function Testimonials() {
  return (
    <section className="relative py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-brand-lime">Client Trust</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-white">
            Trusted by organizations across the country
          </h2>
        </div>
        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 90}>
              <figure className="h-full rounded-2xl border border-white/10 bg-brand-navy2/60 p-8 card-hover">
                <Quote className="h-8 w-8 text-brand-lime/40" />
                <div className="mt-4 flex gap-1">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-brand-orange text-brand-orange" />
                  ))}
                </div>
                <blockquote className="mt-4 text-slate-300 leading-relaxed">“{t.quote}”</blockquote>
                <figcaption className="mt-6 border-t border-white/10 pt-4">
                  <p className="font-semibold text-white">{t.name}</p>
                  <p className="text-sm text-slate-400">{t.org}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
